import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

function sortByCategory(features) {
  const categories = {};
  const alphabetical = {};
  features.forEach(feature => {
    if (!Object.keys(categories).includes(feature.category)) {
      categories[feature.category] = [];
    }
    categories[feature.category].push(<p key={feature.key}>{feature.display}</p>);
  });
  Object.keys(categories)
    .sort()
    .forEach(key => {
      alphabetical[key] = categories[key];
    });
  return alphabetical;
}

class PropertyFeatures extends React.Component {
  render() {
    const categories = sortByCategory(this.props.hotel.features);
    const sections = [];
    for (const category in categories) {
      if (category !== '') {
        sections.push(
          <div key={category} className="col-md-4">
            <h3>{category}</h3>
            {categories[category]}
          </div>
        );
      }
    }
    return (
      <div className="row">
        <div className="col-md-12">
          <h1 className="hotel-detail-subhead">
            Amenities&nbsp;<Button onClick={this.props.handleEdit}>Edit</Button>
          </h1>
          <div className="row">
            <div className="col-md-12">{sections}</div>
          </div>
        </div>
      </div>
    );
  }
}
PropertyFeatures.propTypes = {
  hotel: PropTypes.object.isRequired,
  handleEdit: PropTypes.func.isRequired,
};
export default PropertyFeatures;



// WEBPACK FOOTER //
// src/routes/hotels/components/PropertyFeaturesView.js